import { Skeleton } from '@intigral/shared';
import sliderStyles from './slider.module.sass';
import styles from './slide-skeleton.module.sass';

export const SlideSkeleton = () => {
    return (
        <div className={sliderStyles['slider-wrapper']}>
            <Skeleton height="100%" />
            <div className={styles.skeleton}>
                <div className={styles.thumbnails}>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton />
                </div>
                <div className={styles.controls}>
                    <div className={styles.description}>
                        <Skeleton />
                    </div>
                    <div className={styles.details}>
                        <Skeleton />
                    </div>
                    <div className={styles.buttons}>
                        <Skeleton />
                    </div>
                </div>
            </div>
        </div>
    );
};
